export default "__VITE_ASSET__2iCNB6cn__"